import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

import store from '@/store'

import { jwtDecode } from 'jwt-decode'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { layout: 'default' },
  },
  {
    path: '/login',
    name: 'Login',
    meta: { layout: 'centered' },
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    meta: { layout: 'centered' },
    component: () => import('@/views/Logout.vue')
  },
  { path: '/startpage', name: 'Startseite', component: () => import('@/views/Startpage.vue'), meta: { layout: 'default' } },
  { path: '/layout-editor', name: 'Layout Editor', component: () => import('@/views/LayoutEditor.vue'), meta: { layout: 'default' } },
  { path: '/settings', name: 'Settings', component: () => import('@/views/Settings.vue'), meta: { layout: 'default' } },
  { path: '/logbuch', name: 'Logbuch', component: () => import('@/views/Logbuch.vue'), meta: { layout: 'default' } },
  { path: '/contacts', name: 'Contacts', component: () => import('@/views/Contacts.vue'), meta: { layout: 'default' } },
  { path: '/magazine', name: 'Magazine', component: () => import('@/views/magazine/Index.vue'), meta: { layout: 'default' } },
  { path: '/blog', name: 'Blog', component: () => import('@/views/blog/Index.vue'), meta: { layout: 'default' } },
  { path: '/blog/new', name: 'BlogNew', component: () => import('@/views/blog/new.vue'), meta: { layout: 'default' } },
  { path: '/blog/:id', name: 'BlogEdit', component: () => import('@/views/blog/slug.vue'), meta: { layout: 'default' } },
  { path: '/me', name: 'Me', component: () => import('@/views/Me.vue'), meta: { layout: 'default' } },
  { path: '/mediathek', name: 'Mediathek', component: () => import('@/views/Mediathek.vue'), meta: { layout: 'default' } },
  { path: '/artworks-of-the-month', name: 'ArtworksOfTheMonth', component: () => import('@/views/ArtworksOfTheMonth.vue'), meta: { layout: 'default' } },

  { path: '/exhibitions', name: 'Exhibitions', component: () => import('@/views/Exhibitions.vue'), meta: { layout: 'default' } },
  { path: '/exhibition/:slug', name: 'ExhibitionSingle', component: () => import('@/views/exhibition/slug.vue'), meta: { layout: 'default' } },
  { path: '/exhibition', name: 'ExhibitionNew', component: () => import('@/views/exhibition/index.vue'), meta: { layout: 'default' } },

  { path: '/info-grid', name: 'InfoGrid', component: () => import('@/views/InfoGrid.vue'), meta: { layout: 'default' } },

  { path: '/aenderungen', name: 'ArtworkChangelogs', component: () => import('@/views/ArtworkChangelogs.vue'), meta: { layout: 'default' } },
  { path: '/artworks', name: 'Artworks', component: () => import('@/views/Artworks.vue'), meta: { layout: 'default' } },
  { path: '/artwork/:slug', name: 'ArtworkSingle', component: () => import('@/views/artwork/slug.vue'), meta: { layout: 'default' } },
  { path: '/artwork', name: 'ArtworkNew', component: () => import('@/views/artwork/index.vue'), meta: { layout: 'default' } },
  
  { path: '/artists', name: 'Artists', component: () => import('@/views/Artists.vue'), meta: { layout: 'default' } },
  { path: '/artist/:slug', name: 'ArtistSingle', component: () => import('@/views/artist/slug.vue'), meta: { layout: 'default' } },
  { path: '/artist', name: 'ArtistNew', component: () => import('@/views/artist/index.vue'), meta: { layout: 'default' } },
  {
    path: '/register',
    name: 'Register',
    meta: { layout: 'centered' },
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/info',
    name: 'Info',
    meta: { layout: 'centered' },
    component: () => import('@/views/Info.vue')
  },
  {
    path: '/update-tags',
    name: 'UpdateTags',
    meta: { layout: 'default' },
    component: () => import('@/views/UpdateTags.vue')
  },
  {
    path: '/error',
    name: 'Error',
    meta: { layout: 'centered' },
    component: () => import('@/views/Error.vue')
  },
  { path: "*", component: () => import('@/views/404.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


const publicRoutes = "Login Info Register Registration Logout Error" 
router.beforeResolve(async (to, from, next) => {
  if(publicRoutes.includes(to.name)){
    /* IF ROUTES ARE PUBLIC, THEN JUST GO */
    next()
  }else{
    /* CHECK IF APOLLO TOKEN EXISTS */
    let token = localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN)
    if(!token){
      return next('/login')
    }
    /* CHECK IF APOLLO TOKEN IS EXPIRED */
    try{
      let decoded = jwtDecode(token)
      let exp = decoded.exp * 1000 // Convert to milliseconds
      console.log('[Router Guard] Token exp:', new Date(exp), 'Now:', new Date(Date.now()), 'Expired:', exp < Date.now())
      if( exp < Date.now()){
        console.log('[Router Guard] Token expired, redirecting to logout')
        next({ path: '/logout', replace: true })
        return
      }
    }catch(err){
      console.log('[Router Guard] Token decode error:', err)
      next({ path: '/logout', replace: true })
      return
    }
    /* CHECK IF USER OBJECT IN STORE */
    if(!store.getters.user){
      let result = await store.dispatch('getUser', token)
      if(!result) return next('/logout')
    }

    const isRestrictedCurator = store.getters.isCurator && !store.getters.isCore
    if(isRestrictedCurator){
      const path = to.path || ''
      if(
        path.startsWith('/magazine')
      ){
        return next('/artists')
      }
    }

    // Artist route restrictions
    const isRestrictedArtist = store.getters.isArtist && !store.getters.isCore
    if(isRestrictedArtist){
      const path = to.path || ''
      if(path.startsWith('/artists') || path.startsWith('/magazine')){
        return next('/me')
      }
    }

    // Changelog route guard - core only
    if((to.path || '').startsWith('/aenderungen') && !store.getters.isCore){
      return next('/me')
    }

    // Blog route guard - requires blog role or core
    const path = to.path || ''
    if(path.startsWith('/blog') && !store.getters.hasBlogRole && !store.getters.isCore){
      return next('/me')
    }

    next()
  }
})

export default router
